import { clearanceTypes } from './mockData';

/** Canonical category strings (stored on chains / used in dropdowns). */
export const CATEGORY_RA_BILL_RELATED = 'RA Bill Related';
export const BANK_GUARANTEE_CATEGORY = 'B.G / Insurance Bonds';
export const CATEGORY_CLEARANCES = 'Clearances';
export const CATEGORY_MILESTONE_EOT_RELATED = 'Milestone / EOT Related';
/** @deprecated Prefer CATEGORY_MILESTONE_EOT_RELATED */
export const CATEGORY_MILESTONE_EOT_APPROVALS = CATEGORY_MILESTONE_EOT_RELATED;
export const CATEGORY_DEVIATIONS_EXTRA_ITEMS_RELATED = 'Deviations / Extra Items Related';
export const CATEGORY_VETTING_DRAWINGS_CIVIL = 'Vetting of Drawings-Civil';
export const CATEGORY_VETTING_DRAWINGS_MEP = 'Vetting of Drawings-MEP';
export const CATEGORY_SCOPE_OF_AGREEMENT = 'Scope of Agreement';
export const CATEGORY_MATERIAL_APPROVALS = 'Material Approvals';
export const CATEGORY_QUALITY_QA_AUDIT = 'Quality / QA-QA & Audit';
export const CATEGORY_SAFETY_RELATED = 'Safety Related';
export const CATEGORY_APPROVALS = 'Approvals';
export const CATEGORY_TEST_REPORTS = 'Test Reports';
export const CATEGORY_COST_ADJUSTMENT_10CC = 'Cost adjustment for 10CC/10CA';
export const CATEGORY_INVENTORY_LIST = 'Inventory list';
export const CATEGORY_HORTICULTURE_RELATED = 'Horticulture related';
export const CATEGORY_DRAWING_ARCHITECTURAL = 'Design / Drawing – Architectural';
export const CATEGORY_DRAWING_STRUCTURAL = 'Design / Drawing – Structural';
export const CATEGORY_DRAWING_MEP = 'Design / Drawing – MEP, Fire & Solar';

export const DRAWING_DESIGN_CORRESPONDENCE_CATEGORIES = [
  CATEGORY_DRAWING_ARCHITECTURAL,
  CATEGORY_DRAWING_STRUCTURAL,
  CATEGORY_DRAWING_MEP,
];

/** Legacy DB / demo values → current form value (for dropdowns). */
export const LEGACY_CATEGORY_TO_CURRENT = {
  'RA Bill Details': CATEGORY_RA_BILL_RELATED,
  'Bank Guarantee': BANK_GUARANTEE_CATEGORY,
  'Bank Guarantees / Insurance Bonds': BANK_GUARANTEE_CATEGORY,
  Clearance: CATEGORY_CLEARANCES,
  'Milestone shifting/ EOT': CATEGORY_MILESTONE_EOT_RELATED,
  'Milestone / EOT Approvals': CATEGORY_MILESTONE_EOT_RELATED,
  'Deviations / Extra Items': CATEGORY_DEVIATIONS_EXTRA_ITEMS_RELATED,
  'Agreement and Scope': CATEGORY_SCOPE_OF_AGREEMENT,
  'Drawing / Design': CATEGORY_DRAWING_ARCHITECTURAL,
  'Material Approval': CATEGORY_MATERIAL_APPROVALS,
  'Quality / QA-QC': CATEGORY_QUALITY_QA_AUDIT,
  Safety: CATEGORY_SAFETY_RELATED,
};

/** UI label for stored category (legacy rows show updated names). */
export const displayCorrespondenceCategory = (stored) => {
  if (stored == null || stored === '') return 'General';
  return LEGACY_CATEGORY_TO_CURRENT[stored] || stored;
};

export const normalizeCategoryForForm = (stored) => {
  if (!stored) return 'General';
  return LEGACY_CATEGORY_TO_CURRENT[stored] || stored;
};

export const isBankGuaranteeCategory = (category) =>
  category === 'Bank Guarantee'
  || category === BANK_GUARANTEE_CATEGORY
  || category === 'Bank Guarantees / Insurance Bonds';

export const isDrawingDesignCorrespondenceCategory = (category) =>
  DRAWING_DESIGN_CORRESPONDENCE_CATEGORIES.includes(category)
  || category === 'Drawing / Design';

export const matchesRaBillCategory = (c) =>
  c === CATEGORY_RA_BILL_RELATED || c === 'RA Bill Details';

export const matchesClearanceCategory = (c) =>
  c === CATEGORY_CLEARANCES || c === 'Clearance';

export const matchesMilestoneEotCategory = (c) =>
  c === CATEGORY_MILESTONE_EOT_RELATED
  || c === 'Milestone / EOT Approvals'
  || c === 'Milestone shifting/ EOT';

export const matchesDeviationsExtraItemsCategory = (c) =>
  c === CATEGORY_DEVIATIONS_EXTRA_ITEMS_RELATED || c === 'Deviations / Extra Items';

export const matchesScopeAgreementCategory = (c) =>
  c === CATEGORY_SCOPE_OF_AGREEMENT || c === 'Agreement and Scope';

export const matchesQualityCategory = (c) =>
  c === CATEGORY_QUALITY_QA_AUDIT || c === 'Quality / QA-QC';

export const matchesMaterialCategory = (c) =>
  c === CATEGORY_MATERIAL_APPROVALS || c === 'Material Approval';

export const matchesSafetyCategory = (c) =>
  c === CATEGORY_SAFETY_RELATED || c === 'Safety';

const drawingDesignFields = [
  { key: 'drawing_number', label: 'Drawing Number', type: 'text', required: false },
  { key: 'revision_number', label: 'Revision Number', type: 'text', required: false },
  { key: 'drawing_date', label: 'Drawing Date', type: 'date', required: false },
  { key: 'approval_requirement', label: 'Approval Requirement', type: 'text', required: false },
];

export const categoryFieldConfig = {
  [CATEGORY_RA_BILL_RELATED]: [
    { key: 'ra_no', label: 'RA No', type: 'number', required: false },
    { key: 'ra_ref', label: 'RA Ref', type: 'text', required: false },
    { key: 'period_from', label: 'Period From', type: 'date', required: false },
    { key: 'period_to', label: 'Period To', type: 'date', required: false },
    { key: 'gross_work_done', label: 'Gross Value (₹)', type: 'number', required: false },
    { key: 'deductions_total', label: 'Deductions (₹)', type: 'number', required: false },
    { key: 'net_payable', label: 'Net Payable (₹)', type: 'number', required: false },
    { key: 'paid_value', label: 'Paid Value (₹)', type: 'number', required: false },
    { key: 'ra_status', label: 'RA Status', type: 'select', required: false, options: ['Draft', 'Submitted', 'Paid', 'Certified', 'Closed'] },
    { key: 'payment_status', label: 'Payment Status', type: 'select', required: false, options: ['Unpaid', 'Part Paid', 'Paid', 'Withheld'] },
    { key: 'payment_due_date', label: 'Payment Due Date', type: 'date', required: false },
    { key: 'ra_approved_quantities', label: 'Approved Quantities', type: 'number', required: false },
  ],
  [BANK_GUARANTEE_CATEGORY]: [
    { key: 'bg_type', label: 'Instrument Type', type: 'select', required: false, options: ['Performance Bank Guarantee', 'Security Bank Guarantee', 'Advance Bank Guarantee', 'Insurance Bond', 'Surety Bond'] },
    { key: 'bg_purpose', label: 'BG / Insurance Bond Purpose', type: 'text', required: false },
    { key: 'bg_number', label: 'BG / Bond No', type: 'text', required: false },
    { key: 'bg_bank_name', label: 'Bank / Insurance Company', type: 'text', required: false },
    { key: 'bg_ifsc', label: 'IFSC / Registration Code', type: 'text', required: false },
    { key: 'bg_branch', label: 'Branch / Office', type: 'text', required: false },
    { key: 'bg_amount', label: 'BG Amount (₹)', type: 'number', required: false },
    { key: 'bg_issue_date', label: 'Issue Date', type: 'date', required: false },
    { key: 'bg_expiry_date', label: 'ValidUpto', type: 'date', required: false },
    { key: 'bg_claim_expiry_date', label: 'Claim ValidUpto', type: 'date', required: false },
    { key: 'bg_status', label: 'BG Status', type: 'select', required: false, options: ['Active', 'Expiring', 'Renewal Requested', 'Renewed', 'Released', 'Invoked', 'Closed'] },
  ],
  [CATEGORY_CLEARANCES]: [
    { key: 'clearance_type', label: 'Clearance Type', type: 'select', required: false, options: clearanceTypes },
    { key: 'authority', label: 'Authority', type: 'text', required: false },
    { key: 'submission_date', label: 'Submission Date', type: 'date', required: false },
    { key: 'target_date', label: 'Target Date', type: 'date', required: false },
    { key: 'clearance_status', label: 'Status', type: 'select', required: false, options: ['Draft', 'Submitted', 'Under Review', 'Approved', 'Rejected', 'Expired'] },
    { key: 'clearance_remarks', label: 'Remarks', type: 'text', required: false },
  ],
  [CATEGORY_MILESTONE_EOT_RELATED]: [
    { key: 'request_no', label: 'Request No', type: 'text', required: false },
    { key: 'milestone_id', label: 'Milestone', type: 'number', required: false },
    { key: 'eot_days_requested', label: 'EOT Days Requested', type: 'number', required: false },
    { key: 'requested_completion_date', label: 'Requested Date', type: 'date', required: false },
    { key: 'reason_category', label: 'Reason', type: 'select', required: false, options: ['Hindrance', 'Drawing delay', 'Client decision', 'Design change', 'Force majeure', 'Utility shifting', 'Other'] },
    { key: 'financial_impact_applicable', label: 'Financial Impact', type: 'select', required: false, options: ['Yes', 'No'] },
    { key: 'estimated_cost_impact', label: 'Estimated Cost Impact (₹)', type: 'number', required: false },
    { key: 'ld_risk_impact', label: 'LD Risk / Exposure (₹)', type: 'number', required: false },
    { key: 'financial_remarks', label: 'Financial Impact Remarks', type: 'text', required: false },
    { key: 'shift_status', label: 'Status', type: 'select', required: false, options: ['Draft', 'Submitted', 'Under Review', 'Approved', 'Rejected', 'Withdrawn'] },
    { key: 'eot_reason', label: 'Remarks', type: 'text', required: false },
  ],
  'Specialized Items': [
    { key: 'item_name', label: 'Item Name / Description', type: 'text', required: false },
    { key: 'spec_ref', label: 'Specification Reference', type: 'text', required: false },
    { key: 'vendor_name', label: 'Manufacturer / Vendor', type: 'text', required: false },
    { key: 'country_of_origin', label: 'Country of Origin', type: 'text', required: false },
    { key: 'lead_time_days', label: 'Lead Time (Days)', type: 'number', required: false },
    { key: 'expected_delivery_date', label: 'Expected Delivery Date', type: 'date', required: false },
    { key: 'fat_required', label: 'FAT Required', type: 'select', required: false, options: ['Yes', 'No'] },
    { key: 'warranty_months', label: 'Warranty Period (Months)', type: 'number', required: false },
    { key: 'special_instructions', label: 'Special Instructions', type: 'textarea', required: false },
  ],
  [CATEGORY_DEVIATIONS_EXTRA_ITEMS_RELATED]: [
    { key: 'deviation_no', label: 'Reference No', type: 'text', required: false },
    { key: 'deviation_description', label: 'Title', type: 'text', required: false },
    { key: 'boq_item_ref', label: 'BOQ Item', type: 'text', required: false },
    { key: 'original_qty', label: 'Original Quantity', type: 'number', required: false },
    { key: 'revised_qty', label: 'Revised Quantity', type: 'number', required: false },
    { key: 'unit', label: 'Unit (Nos/Sqm/etc.)', type: 'text', required: false },
    { key: 'original_rate', label: 'Original Rate (₹)', type: 'number', required: false },
    { key: 'revised_rate', label: 'Revised Rate (₹)', type: 'number', required: false },
    { key: 'deviation_status', label: 'Status', type: 'select', required: false, options: ['Draft', 'Submitted', 'Under Review', 'Approved', 'Rejected'] },
    { key: 'deviation_remarks', label: 'Remarks', type: 'text', required: false },
  ],
  [CATEGORY_SCOPE_OF_AGREEMENT]: [
    { key: 'change_order_ref', label: 'Change Order Ref', type: 'text', required: false },
    { key: 'scope_summary', label: 'Scope Change Summary', type: 'text', required: false },
    { key: 'scope_value_impact', label: 'Estimated Value Impact (₹)', type: 'number', required: false },
    { key: 'approval_stage', label: 'Approval Stage', type: 'text', required: false },
  ],
  [CATEGORY_DRAWING_ARCHITECTURAL]: drawingDesignFields,
  [CATEGORY_DRAWING_STRUCTURAL]: drawingDesignFields,
  [CATEGORY_DRAWING_MEP]: drawingDesignFields,
  [CATEGORY_VETTING_DRAWINGS_CIVIL]: drawingDesignFields,
  [CATEGORY_VETTING_DRAWINGS_MEP]: drawingDesignFields,
  [CATEGORY_MATERIAL_APPROVALS]: [
    { key: 'material_name', label: 'Material Name', type: 'text', required: false },
    { key: 'material_make', label: 'Make / Brand', type: 'text', required: false },
    { key: 'test_report_ref', label: 'Test Report Ref', type: 'text', required: false },
    { key: 'material_qty', label: 'Proposed Quantity', type: 'number', required: false },
  ],
  [CATEGORY_QUALITY_QA_AUDIT]: [
    { key: 'checklist_no', label: 'Checklist No', type: 'text', required: false },
    { key: 'qaqc_category', label: 'Category', type: 'text', required: false },
    { key: 'qaqc_result', label: 'Result', type: 'select', required: false, options: ['Pass', 'Fail', 'Conditional'] },
    { key: 'qaqc_status', label: 'Status', type: 'select', required: false, options: ['Approved', 'Rework', 'Under Review'] },
    { key: 'inspection_date', label: 'Date', type: 'date', required: false },
    { key: 'inspector_name', label: 'Inspector', type: 'text', required: false },
    { key: 'parameters_checked', label: 'Parameters Checked', type: 'text', required: false },
    { key: 'defects_found', label: 'Defects Found', type: 'text', required: false },
    { key: 'corrective_action', label: 'Corrective Action', type: 'text', required: false },
    { key: 'retest_date', label: 'Retest Date', type: 'date', required: false },
    { key: 'qaqc_remarks', label: 'Remarks', type: 'text', required: false },
  ],
  [CATEGORY_SAFETY_RELATED]: [
    { key: 'incident_ref', label: 'Incident / Observation Ref', type: 'text', required: false },
    { key: 'incident_date', label: 'Incident Date', type: 'date', required: false },
    { key: 'safety_severity', label: 'Severity', type: 'text', required: false },
    { key: 'closure_target_date', label: 'Closure Target Date', type: 'date', required: false },
  ],
  [CATEGORY_APPROVALS]: [
    { key: 'approval_ref', label: 'Approval reference', type: 'text', required: false },
    { key: 'approval_subject', label: 'Description / subject', type: 'text', required: false },
    { key: 'approval_authority', label: 'Authority / approver', type: 'text', required: false },
    { key: 'approval_request_date', label: 'Request date', type: 'date', required: false },
    { key: 'approval_status', label: 'Status', type: 'select', required: false, options: ['Draft', 'Submitted', 'Under Review', 'Approved', 'Rejected', 'On Hold'] },
  ],
  [CATEGORY_TEST_REPORTS]: [
    { key: 'test_report_ref', label: 'Test Report Ref', type: 'text', required: false },
    { key: 'test_report_date', label: 'Test Report Date', type: 'date', required: false },
    { key: 'test_type', label: 'Test Type', type: 'text', required: false },
  ],
  [CATEGORY_COST_ADJUSTMENT_10CC]: [
    { key: 'adjustment_ref', label: 'Adjustment Ref', type: 'text', required: false },
    { key: 'adjustment_period', label: 'Period', type: 'text', required: false },
    { key: 'adjustment_amount', label: 'Amount (₹)', type: 'number', required: false },
  ],
  [CATEGORY_INVENTORY_LIST]: [
    { key: 'inventory_ref', label: 'Inventory List Ref', type: 'text', required: false },
    { key: 'inventory_period', label: 'Period / As-on Date', type: 'date', required: false },
  ],
  [CATEGORY_HORTICULTURE_RELATED]: [
    { key: 'horticulture_scope', label: 'Scope / Location', type: 'text', required: false },
    { key: 'horticulture_ref', label: 'Reference', type: 'text', required: false },
  ],
  'Contractual / Claims': [
    { key: 'claim_ref', label: 'Claim Reference', type: 'text', required: false },
    { key: 'claim_amount', label: 'Claim Amount (₹)', type: 'number', required: false },
    { key: 'claim_basis', label: 'Claim Basis', type: 'text', required: false },
    { key: 'claim_notice_date', label: 'Notice Date', type: 'date', required: false },
  ],
};

/** Resolve category-specific fields for legacy stored categories. */
export const getCategoryFieldConfig = (category) => {
  const key = LEGACY_CATEGORY_TO_CURRENT[category] || category;
  return categoryFieldConfig[key] || [];
};
